const type = {
  GOODS: 0,
  SHOP: 1
};

export default type;
